import React from "react";
import PropTypes from "prop-types";
import { ImageSlider } from "./ImageSlider";
import "./Modal.css";

const Modal = ({ project, onClose }) => {
  if (!project) return null;

  return (
    <div className="prj-modal">
      {/* modal window */}
      <div className="prj-modal-content">
        <ImageSlider imageURLs={project.slideImages} />

        <div className="prj-text">
          <h1 className="prj-title">{project.title}</h1>
          {project.descriptionLong /* already JSX from createParagraphs */}
        </div>

        <div className="prj-close-modal" onClick={onClose}>
          ×
        </div>
      </div>

      {/* overlay AFTER content, so CSS sibling selector can hide it */}
      <div className="prj-overlay" onClick={onClose} />
    </div>
  );
};

/* ---------- prop-types ---------- */
Modal.propTypes = {
  onClose: PropTypes.func.isRequired,
  project: PropTypes.shape({
    title: PropTypes.string.isRequired,
    descriptionLong: PropTypes.node.isRequired,
    mediaType: PropTypes.oneOf(["video", "youTube", "image"]).isRequired,
    mediaUrl: PropTypes.string.isRequired,
    slideImages: PropTypes.array.isRequired,
  }),
};

export default Modal;
